import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";

import "./entity-share.m.css";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";

export default function EntityShare({ title, url }) {
  const [shareMenuOpen, setShareMenuOpen] = useState(false);

  const shareIconSet = [
    { id: "share-facebook", label: "Facebook", url: `https://www.facebook.com/sharer.php?u=${url}` },
    {
      id: "share-x",
      label: "X",
      url: `https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(title)}`,
    },
    { id: "share-whatsapp", label: "Whatsapp", url: `https://api.whatsapp.com/send?text=${url}` },
    { id: "share-mail", label: "E-mail", url: `mailto:?subject=${title}&body=${url}` },
    {
      id: "share-linkedin",
      label: "Linkedin",
      url: `https://www.linkedin.com/shareArticle?url=${url}&title=${encodeURIComponent(title)}`,
    },
  ];
  useEffect(() => {
    const closeShareMenu = () => setShareMenuOpen(false);
    document.body.addEventListener("click", closeShareMenu);

    return () => {
      document.body.removeEventListener("click", closeShareMenu);
    };
  }, []);

  return (
    <div styleName="entity-share-menu-container">
      <div styleName="share-icons-div">
        <div tabIndex={0} styleName="entity-share" onClick={() => setShareMenuOpen(true)}>
          <span>SHARE</span>
          <SvgIconHandler type="recipe-share-menu" height="24px" width="24px" viewBox="0 0 24 24" />
        </div>
      </div>
      {shareMenuOpen && (
        <div styleName={"entity-share-menu"}>
          <>
            {shareIconSet.map((item, index) => {
              return (
                <Link key={index} href={item?.url} target="_blank">
                  <SvgIconHandler type={item.id} height="32px" width="32px" viewBox="0 0 32 32" />
                  <span>{item?.label}</span>
                </Link>
              );
            })}
          </>
        </div>
      )}
    </div>
  );
}
